import * as Communicator from "@ts3d-hoops/web-viewer";
export enum selectionFlag {
    SelectByCode = 1,
    SelectByLink,
    SelectByTree,
    SelectByIsolate,
    SelectByProperty,
}
export default class CSelectionManager extends Communicator.Selection
    .SelectionManager {
    private selectionResult: NodeId[] = [];
    private selectionFlags: number[] = [];
    constructor(
        viewer: Communicator.WebViewer,
        callbackManager: Communicator.ICallbackManager,
        engine: Communicator.IScEngine,
        model: Communicator.Model,
        modelStructure: Communicator.IModelStructure
    ) {
        super(viewer, callbackManager, engine, model, modelStructure);
    }

    addFlag(selectionFlag: selectionFlag): void {
        if (!this.selectionFlags.includes(selectionFlag))
            this.selectionFlags.push(selectionFlag);
    }

    removeFlag(selectionFlag: selectionFlag): void {
        if (this.selectionFlags.includes(selectionFlag)) {
            this.selectionFlags = this.selectionFlags.filter(
                (flag) => flag !== selectionFlag
            );
        }
    }

    getFlag(): number[] {
        return this.selectionFlags;
    }
    addNodeSelectWithoutTrigger(arr: NodeId[]): void {
        this.selectionResult = arr;
    }
    getResultsExtends(): NodeId[] {
        if (this.selectionResult.length > 0) {
            return this.selectionResult;
        }
        const selectionItems = this.getResults();
        return selectionItems.map((item) => item.getNodeId());
    }
}
